var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFavoriteAddress = function SvgIconFavoriteAddress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.382 1.003C5.71157 0.98271 4.10134 1.62603 2.9048 2.79182C1.70826 3.95761 1.0232 5.55062 1.00002 7.22102C1.00002 9.33502 2.019 11.34 4.08 13.321C5.1 14.284 12.501 21.516 12.996 21.997L21.912 13.321C24.003 11.337 25 9.33202 25 7.22102C24.9792 5.55099 24.2961 3.95752 23.1008 2.79097C21.9056 1.62442 20.296 0.980205 18.626 0.999953C17.4915 0.992868 16.3755 1.28691 15.3917 1.85188C14.408 2.41685 13.5916 3.23261 13.026 4.21602L12.997 4.30305L12.968 4.21602C12.4018 3.23662 11.5874 2.42381 10.6068 1.85969C9.62626 1.29558 8.51426 1.00011 7.38301 1.003H7.382Z",
    fill: "white",
    stroke: "#939598",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFavoriteAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_favorite_address.6993e769.svg";
export { ForwardRef as ReactComponent };